import React, { useEffect, useRef } from 'react';
import { Card, CardBody } from 'reactstrap';
import isEqual from 'lodash/isEqual';
import am4lang_es_ES from "@amcharts/amcharts4/lang/es_ES"
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

const am4themes_donutTheme = (target) => {
  if(target instanceof am4core.ColorSet){
    target.list = [
      am4core.color("#1D1F3F"),
      am4core.color("#097AAF"),
      am4core.color("rgba(0, 117, 172, 0.5)")
    ]
  }
};

am4core.useTheme(am4themes_donutTheme);

const DonutChart = ({ title, data, iconString }) => {
  const chartRef = useRef();

  useEffect(() => {
    let chart = am4core.create(chartRef.current, am4charts.PieChart);
    chart.language.locale = am4lang_es_ES;
    chart.data = data;
    chart.innerRadius = 80;
    chart.radius = 100;
    chart.responsive.enabled = true;

    let series = chart.series.push(new am4charts.PieSeries());
    series.dataFields.category = 'category';
    series.dataFields.value = 'value';
    series.labels.template.disabled = true;
    series.ticks.template.disabled = true;

    let legend = new am4charts.Legend();
    chart.legend = legend;
    legend.maxWidth = undefined;
    legend.fontSize = 11;
    legend.valueLabels.template.align = "righ    series.t";
    legend.valueLabels.template.textAlign = "end";

    let label = series.createChild(am4core.Label);
    label.html = iconString;
    label.horizontalCenter = "middle";
    label.verticalCenter = "middle";
    label.fontSize = 40;

    return () => { chart.dispose() };
  }, [data]);

  return (
    <React.Fragment>
      <Card className="chart-card">
        <CardBody>
          <div
            ref={chartRef}
            style={{ height: '100%', width: '100%' }}
          />
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default React.memo(DonutChart, (prevProps, nextProps) => isEqual(prevProps, nextProps));
